import React, { Component } from 'react';
import CommonPlannedReturn from '../commons/CommonPlannedReturn';
import { START_RETURN_BOOKING } from 'app/constants';


/**
 * Desktop version of planned return.
 *
 * When user click to `Add a return trip` button `props.input.onChange`
 * will be called with `START_RETURN_BOOKING` constant.
 */
class DesktopPlannedReturn extends Component {
  handleAddReturnTrip = () => {
    this.props.input.onChange(START_RETURN_BOOKING);
  }

  render() {
    return (
      <CommonPlannedReturn onClickAdd={this.handleAddReturnTrip} />
    );
  }
}

// TODO: move to Flow types
// DesktopPlannedReturn.propTypes = {
//   input: PropTypes.object
// };

export default DesktopPlannedReturn;
